export const BACKEND_ERROR_EVENT = 'system:backendError';

export const EXCLUDED_ERROR_CODES: readonly number[] = [400, 401, 403, 409, 500];
